import React from 'react';
import { Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-950 border-t border-slate-800 py-16" data-id="element-652">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-653">
        <div className="grid md:grid-cols-4 gap-12" data-id="element-654">
          {/* Brand */}
          <div className="md:col-span-2" data-id="element-655">
            <div className="text-2xl font-bold tracking-tight text-white mb-4" data-id="element-656">
              Sponsr<span className="text-cyan-500" data-id="element-657">AI</span>
            </div>
            <p className="text-slate-400 mb-6 max-w-md" data-id="element-658">
              AI-powered sponsorship matching that connects brands with the
              perfect events and organizers with ideal sponsors.
            </p>
            <a href="mailto:info@sponsrai.se" className="inline-flex items-center gap-2 text-cyan-400 hover:text-cyan-300 transition-colors" data-id="element-659">
              <Mail size={18} data-id="element-660" />
              info@sponsrai.se
            </a>
          </div>

          {/* Links */}
          <div data-id="element-661">
            <h4 className="text-white font-semibold mb-4" data-id="element-662">Platform</h4>
            <ul className="space-y-3" data-id="element-663">
              <li data-id="element-664">
                <a href="#how-it-works" className="text-slate-400 hover:text-white transition-colors" data-id="element-665">
                  How it Works
                </a>
              </li>
              <li data-id="element-666">
                <a href="#brands" className="text-slate-400 hover:text-white transition-colors" data-id="element-667">
                  For Brands
                </a>
              </li>
              <li data-id="element-668">
                <a href="#organizers" className="text-slate-400 hover:text-white transition-colors" data-id="element-669">
                  For Organizers
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-670">
            <h4 className="text-white font-semibold mb-4" data-id="element-671">Support</h4>
            <ul className="space-y-3" data-id="element-672">
              <li data-id="element-673">
                <a href="mailto:info@sponsrai.se" className="text-slate-400 hover:text-white transition-colors" data-id="element-674">
                  Contact Us
                </a>
              </li>
              <li data-id="element-675">
                <span className="text-slate-400" data-id="element-676">FAQ (Coming Soon)</span>
              </li>
              <li data-id="element-677">
                <span className="text-slate-400" data-id="element-678">Privacy Policy</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-679">
          <p className="text-slate-500 text-sm" data-id="element-680">
            © 2024 SponsrAI. All rights reserved.
          </p>
          <p className="text-slate-500 text-sm" data-id="element-681">
            Questions?{' '}
            <a href="mailto:info@sponsrai.se" className="text-cyan-400 hover:text-cyan-300" data-id="element-682">
              info@sponsrai.se
            </a>
          </p>
        </div>
      </div>
    </footer>;
}